import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useAuth0} from '@auth0/auth0-react';

export const LoginPage = () => {
  const {loginWithRedirect} = useAuth0();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint:
          searchParams.get('type') === 'signup' ? 'signup' : undefined,
      },
    });
  }, [loginWithRedirect, searchParams]);

  return null;
};
